import { useFormContext } from "src/lib/templates";
import { InitialValueDefinition } from "../types";

export const useUserInfoFormContext = () => useFormContext<InitialValueDefinition>();
